import { z } from 'zod';

import { defineFcm } from '../shared/factory';

export const FCM_PSF_OG_IMAGE = defineFcm('psf_og_image')
	.asJson(
		z.object({
			enabled: z.boolean().optional(),
			experimentName: z.string().optional(),
		}),
	)
	.withDefault({ enabled: false, experimentName: undefined })
	.toConfig({
		owner: 'squad-platypus',
		scope: ['corgi-front-end', 'corgi-middle-end'],
		context: 'PSF share links (slide-up, /psf/share) and their link previews',
		description: `Gates the OG image experiment. When enabled, PSF share links for variant arms on eligible petitions
			carry an /img/:variant path segment so link-preview crawlers render that arm's og:image. Gates link creation
			only: links already shared keep rendering their arm. Renders are gated separately by psf_og_image_render.
			To switch the experiment off, set enabled: false rather than using Disable. See CHANGE-99397.`,
		supportedGroups: { global: true, locales: true, countries: true },
		template: { enabled: true, experimentName: 'psf_og_image_experiment' },
	});
